import { render, staticRenderFns } from "./PrintPreview.vue?vue&type=template&id=a67e53a2&scoped=true"
import script from "./PrintPreview.vue?vue&type=script&lang=js"
export * from "./PrintPreview.vue?vue&type=script&lang=js"
import style0 from "./PrintPreview.vue?vue&type=style&index=0&id=a67e53a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67e53a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a67e53a2')) {
      api.createRecord('a67e53a2', component.options)
    } else {
      api.reload('a67e53a2', component.options)
    }
    module.hot.accept("./PrintPreview.vue?vue&type=template&id=a67e53a2&scoped=true", function () {
      api.rerender('a67e53a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printpreview/PrintPreview.vue"
export default component.exports